export const NAV_LINKS = [
  { label: 'Projects', href: '/projects', router: true },
  { label: 'Contact', href: '/#contact', router: false },
];

export const FOOTER_EXPLORE_LINKS = [
  { label: 'Projects', href: '/projects', router: true },
];

export const FOOTER_COMPANY_LINKS = [
  { label: 'Contact', href: '/#contact', router: false },
  { label: 'Privacy Policy', href: '/privacy-policy', router: true },
  { label: 'Terms of Service', href: '/terms-of-service', router: true },
];
